import { GetChallengeResponse, SignInitResponse } from '../../class/class';
import { ReduxAction } from '../../enums/const-enums';

export interface OverlayState {
  active?: boolean;
  content?: string;
  message?: string;
  type?: string;
  url?: string;
  messageTitle?: string;
  code?: string;
  resp?: SignInitResponse | GetChallengeResponse;
}

export const initialOverlayState: OverlayState = {};

export interface OverlayStateAction {
  type: ReduxAction;
  payload: OverlayState;
}

export function overlayReducer(
  state: OverlayState = initialOverlayState,
  action: OverlayStateAction,
): OverlayState {
  switch (action.type) {
    case ReduxAction.OVERLAY_UPDATE:
      state = action.payload;
      break;
    case ReduxAction.OVERLAY_CLEAR:
      state = initialOverlayState;
      break;
  }
  return state;
}
